import React from 'react';

/**
 * Compact circular spinner for in-button processing feedback.
 * Replaces rotating action icons (Apple-style: clear status, not ornament).
 */
export function ButtonSpinner({ className = '', size = 'md' }) {
  const classes = ['btn-spinner', size === 'sm' ? 'btn-spinner--sm' : '', className]
    .filter(Boolean)
    .join(' ');
  return <span className={classes} aria-hidden="true" />;
}

/**
 * Show a spinner while busy; otherwise render the action icon.
 */
export function LoadingIcon({ loading, icon: Icon, className }) {
  if (loading) return <ButtonSpinner className={className} />;
  if (!Icon) return null;
  return <Icon className={className} aria-hidden />;
}

/** @deprecated Prefer LoadingIcon / ButtonSpinner — icons no longer spin. */
export function iconSpinClass(loading) {
  return loading ? 'btn-spinner-legacy' : undefined;
}

/**
 * Button with optional leading icon. While `loading`, the icon is replaced
 * by a spinning circle (not a rotating glyph).
 * Pass `loadingLabel` to swap button text during loading; omit to keep the same label.
 */
export default function LoadingButton({
  loading = false,
  icon: Icon,
  children,
  className = 'btn',
  disabled,
  loadingLabel,
  type = 'button',
  ...rest
}) {
  const busy = Boolean(loading || disabled);
  const showLabel = loading && loadingLabel !== undefined ? loadingLabel : children;
  const classes = [className, loading ? 'is-loading' : ''].filter(Boolean).join(' ');
  const showLeading = Boolean(Icon) || loading;

  return (
    <button
      type={type}
      className={classes}
      disabled={busy}
      aria-busy={loading || undefined}
      {...rest}
    >
      {showLeading ? <LoadingIcon loading={loading} icon={Icon} /> : null}
      {showLabel}
    </button>
  );
}
